// Product Add

class AddToCart {
  constructor() {
    this.rivets();

    this.addButtons = [].slice.call(
      document.querySelectorAll('.add-to-cart')
    );
    
    this.addButtons.forEach(button => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        button.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          const cartCount = document.querySelector('.header__cart__count')
          if (key === 13 || e.type === 'click') {
            this.productAdd(button)
            cartCount.classList.add('has-item')
          }
        });
      });
    });

    this.variants = [].slice.call(
      document.querySelectorAll('.product__variants__item')
    );
    
    this.variants.forEach(variant => {
      // ada : support keyboard
      ['click', 'keypress'].forEach(event => {
        variant.addEventListener(event, e => {
          const key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            this.variants.forEach(function(e) {
              e.classList.remove('current');
            });
            this.variantUpdate(variant)
          }
        });
      });
    });

    this.products = [].slice.call(
      document.querySelectorAll('[data-type]')
    );

    this.sizes = [].slice.call(
      document.querySelectorAll('[data-group]')
    );

    this.products.forEach(product => {
      ['click', 'keypress'].forEach(event => {
        product.addEventListener(event, e => {
          this.products.forEach(product => {
            product.classList.remove('current')
          })
          
          product.classList.add('current')
          
          this.sizes.forEach(size => {
            size.classList.remove('active')
            size.classList.remove('current')
            
            if (product.dataset.type === size.dataset.group) {
              size.classList.add('active')
            }
          });
        });
      });
    });
  }

  variantUpdate(element) {
    const currentVariant = element.dataset.id;
    const currentPrice = element.dataset.price;
    const currentName = element.dataset.name;
    const addButton = document.querySelector('.product__btn button');
    const overflowContainer = document.querySelector('.overflow ul');
    const variantParent = element.parentNode.previousElementSibling;
    const variantName = variantParent.querySelector('span');

    if (overflowContainer) {
      overflowContainer.classList.add('active')
    }

    if (!element.classList.contains('current')) {
      element.classList.add('current')
      variantName.innerHTML = '— ' + currentName
    }

    if (element.classList.contains('selectable')) {
      element.classList.add('current')
      variantName.innerHTML = '— ' + currentName
      addButton.querySelector('span').innerHTML = 'Add to Cart — ' + currentPrice
      addButton.classList.remove('inactive')
      addButton.setAttribute('data-cart-add', currentVariant)
    }
  }

  rivets() {

    rivets.formatters.currency = {
      read: function (value) {
        return (value / 100).toFixed(2)
      },
      publish: function (value) {
        return Math.round(parseFloat(value) * 100)
      }
    }

    rivets.formatters.product_variant_id = function (variants) {
      return variants[0].id;
    };

    rivets.formatters.product_title = function (str) {
      const productTitleChunks = flow(
        replace(/\(([^)]+)\)/g, ''),
        trim,
        split(':')
      )(str);

      if (productTitleChunks.length > 1) {
        return _initial(productTitleChunks).join(' ');
      }

      return productTitleChunks[0];
    };

    rivets.formatters.product_url = function (handle, variant_id) {
      var url_param = '';

      if (variant_id !== null) {
        url_param = '?variant=' + variant_id;
      }

      return '/products/' + handle + url_param;
    };

    rivets.formatters.eq = function (value, args) {
      return value === args;
    };

    rivets.formatters.replace = function (str, remove, replace) {
      return str.replace(remove, replace);
    };

    rivets.formatters.remove = function (str, remove) {
      return str.replace(remove, '');
    };

    rivets.formatters.without_spaces_and_trailing_zeros = function (str) {
      return str.replace(/\.00|\s/g, '');
    };

    rivets.formatters.size = function (array) {
      return array.length;
    };

    rivets.binders.addclass = function (el, value) {
      var $el = $(el);

      if (value !== '') {
        if (!$el.hasClass(value)) {
          $el.addClass(value);
        }
      }
    };

    rivets.formatters.remove = function (str, remove) {
      if (typeof str !== 'string') {
        str = str.toString();
      }

      return str.replace(remove, '');
    };

    rivets.formatters.gtprice = function (value, arg) {
      console.log("value: " + value)
      console.log("arg: " + arg)
      return value > arg;
    }
  }

  productAdd(element, amount = 1) {
    let quantity = amount,
      id = element.dataset.cartAdd,
      url = '/cart/add.js',
      data = { 'id': id, 'qty': quantity };

    fetch(url, {
      credentials: 'same-origin',
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
      .catch(error => this.cartError())
      .then(response => this.cartSuccess(element));
  }

  cartSuccess(button) {
    
    jQuery.getJSON('/cart.js', function (cart) {


    });

    fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (cart) {
      console.log(cart)
    }).catch(function (err) {
      console.log(err)
    });
  }

  cartError() {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      alert(data.message + '(' + data.status + '): ' + data.description);
    } else {
      alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
    }
    console.log('error when adding product');
  }
}

const addInit = {
  init() {
    // if element exists init this class
    const addElem = [].slice.call(
      document.querySelectorAll('.add-to-cart')
    );
    if (addElem.length > 0) {
      const buttonWrap = new AddToCart();
    }
  },
};

export default addInit;
